import React, { useState, useEffect, useRef } from "react";
// import PropTypes from "prop-types";

// import { connect } from "react-redux";
// import { bindActionCreators } from "redux";

import OutlinedInput from "@mui/material/OutlinedInput";
import Grid from "@mui/material/Grid";
import Alert from "components/Alert";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import FormDatePicker from "components/FormControls/FormDatePicker";
import moment from "moment";

import {
  Container,
  FilterContainer,
  FilterHeader,
  ScrollContainer,
  ApplyClearButtonContainer,
  SaveApplyClearButtonContainer,
  MultiLabelContainer,
} from "./styles";

import colors from "styles/colors";
import { timeClockClasses } from "@mui/x-date-pickers-pro";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const FilterModal = (props) => {
  const prevProps = usePrevious({
    ...props,
  });

  const [selectedFilters, setSelectedFilters] = useState({
    ...props.selectedFilters,
  });

  useEffect(() => {
    if (
      props &&
      prevProps &&
      JSON.stringify(props.selectedFilters) !==
        JSON.stringify(prevProps.selectedFilters)
    ) {
      setSelectedFilters({ ...props.selectedFilters });
    }
  }, [props.selectedFilters]);

  const {
    open,
    onClose,
    filters,
    autoHeight = false,
    setEqualColSpan = false,
    hideSaveFilterButtons = false,
    onApplyFilter = () => {},
    onSaveFilter = () => {},
    disableSaveApply = false,
  } = props;

  const [alertError, setAlertError] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const handleSelectChange = (event, filterName) => {
    const {
      target: { value },
    } = event;

    setSelectedFilters({
      ...selectedFilters,
      [filterName]: typeof value === "string" ? value.split(",") : value,
    });
  };

  const handleDatePickerChange = (value, filterName) => {
    if (value == null && filterName in selectedFilters) {
      setSelectedFilters({
        ...selectedFilters,
        [filterName]: null,
      });
    } else if (value != null) {
      setSelectedFilters({
        ...selectedFilters,
        [filterName]: moment.utc(value).local().format("DD MMM YYYY"),    
      });
    }
  };

  const handleToggleChange = (value, name) => {
    if (!value) {
      var filters = { ...selectedFilters };

      delete filters[name];

      setSelectedFilters(filters);
    } else {
      setSelectedFilters({ ...selectedFilters, [name]: true });
    }
  };

  const handleAlerted = () => {
    setAlertError("");
    setAlertMessage("");
  };

  const renderFilterToggle = (filter) => {
    const { label, name } = filter;
    const selected = selectedFilters[name];

    return (
      <>
        <InputLabel id={`${name}-label`}>{label}</InputLabel>
        <Switch
          checked={selected}
          labelId={`${name}-label`}
          onChange={(event, value) => {
            handleToggleChange(value, name);
          }}
        />
      </>
    );
    // return
  };

  const renderFilterSelect = (filter) => {
    const { options, label, name, idMap, mapId, mapName } = filter;

    if (!options) {
      return;
    }

    if (!selectedFilters[name]) {
      selectedFilters[name] = [];
    }

    return (
      <>
        <InputLabel id={`${name}-label`}>{label}</InputLabel>
        <Select
          labelId={`${name}-label`}
          className="filter"
          multiple
          value={selectedFilters[name]}
          onChange={(event) => handleSelectChange(event, name)}
          input={<OutlinedInput id="select-multiple-chip" />}
          renderValue={(selected) => (
            <MultiLabelContainer>
              {selected.map((value) => {
                let label = value;

                if (idMap && idMap.length > 0) {
                  if (mapId && mapName) {
                    label = idMap.find((i) => i[mapId] == value)[mapName];
                  } else {
                    label = idMap.find((i) => i.id === value).name;
                  }
                }
                return <Chip key={value} label={label} />;
              })}
            </MultiLabelContainer>
          )}
          MenuProps={MenuProps}
        >
          {options.map((option) => {
            let key = option;
            let value = option;

            if (idMap && idMap.length > 0) {
              if (mapId && mapName) {
                key = value = idMap.find((i) => i[mapName] === option)[mapId];
              } else {
                key = value = idMap.find((i) => i.name === option).id;
              }
            }

            return (
              <MenuItem key={key} value={value}>
                {option}
              </MenuItem>
            );
          })}
        </Select>
      </>
    );
  };

  const renderFilterControl = (idx) => {
    let filterControl = <></>;

    if (filters) {
      filters.forEach((f, index) => {
        if (index + 1 === idx) {
          if (f.type === "boolean") {
            filterControl = renderFilterToggle(f);
          } else if (f.type === "datepicker") {
            filterControl = renderFilterDateTime(f);
          } else {
            filterControl = renderFilterSelect(f);
          }
        }
      });

      return filterControl;
    }
  };

  const renderFilterDateTime = (filter) => {
    const { options, label, name, initialValue } = filter;

    if (!selectedFilters[name]) {
      selectedFilters[name] = [];
    }

    selectedFilters[name] =
      selectedFilters[name].length === 0 &&
      filter.initialValue != undefined &&
      filter.initialValue.length > 0
        ? filter.initialValue
        : Date.parse(selectedFilters[name]) > 0
        ? selectedFilters[name]
        : null;

    return (
      <>
        <InputLabel id={`${name}-label`}>{label}</InputLabel>
        <FormDatePicker
          id={`${name}-Id`}
          type="text"
          name={name}
          showHelpIcon={false}
          required={false}
          placeholder="Select Date Range"
          value={moment(selectedFilters[name])}
          onChange={(value) => handleDatePickerChange(value, name)}
        />
      </>
    );
  };

  const applyFilter = () => {
    if (validateDate()) {
      onApplyFilter(selectedFilters);
      onClose();
    }
  };

  const validateDate = () => {
    if (
      (selectedFilters.StartDate == null && selectedFilters.EndDate != null) ||
      (selectedFilters.EndDate == null && selectedFilters.StartDate != null)
    ) {
      setAlertError("Either Start Date or End Date cannot be empty");
      return false;
    }
    if (
      selectedFilters.StartDate != null &&
      selectedFilters.EndDate != null &&
      Date.parse(selectedFilters.EndDate) <
        Date.parse(selectedFilters.StartDate)
    ) {
      setAlertError("End Date cannot be lesser than Start Date");
      return false;
    }

    return true;
  };

  const clearFilter = () => {
    setSelectedFilters({});
  };

  const applyAndSaveFilter = () => {
    onSaveFilter(selectedFilters);
    onClose();
  };

  const clearAndSaveFilter = () => {
    setSelectedFilters({});
    onSaveFilter({});
    onClose();
  };

  const columnSpan = (idx, columns) => {
    let result = columns;

    if (filters) {
      filters.forEach((f, index) => {
        if (index + 1 === idx) {
          if (f.colSpan) {
            if (f.colSpan === "50%") {
              result = 6;
            } else {
              result = f.colSpan * 4;
            }
            return;
          } else {
            return;
          }
        }
      });

      return result;
    }

    return result;
  };

  let style = {};

  if (autoHeight && setEqualColSpan) {
    style = { height: "auto", top: "42%" };
  } else if (autoHeight) {
    style = { height: "auto" };
  } else {
    style = { height: "70vh" };
  }

  const renderFirstElement = () => {
    if (!setEqualColSpan) {
      return (
        <>
          <Grid item xs={columnSpan(1, 8)}>
            {renderFilterControl(1)}
          </Grid>
          <Grid item xs={columnSpan(2, 4)}>
            {renderFilterControl(2)}
          </Grid>
        </>
      );
    } else {
      return (
        <>
          <Grid item xs={columnSpan(1, 6)}>
            {renderFilterControl(1)}
          </Grid>
          <Grid item xs={columnSpan(2, 6)}>
            {renderFilterControl(2)}
          </Grid>
        </>
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={style}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Container>
        <Alert
          error={alertError}
          message={alertMessage}
          onAlerted={handleAlerted}
        />

        <FilterContainer style={style}>
          <FilterHeader>
            <Typography id="modal-title" variant="h6" component="h2">
              FILTERS
            </Typography>
            <IconButton aria-label="close" onClick={onClose}>
              <CloseIcon sx={{ color: "grey" }} />
            </IconButton>
          </FilterHeader>
          <ScrollContainer>
            <Typography id="modal-description" sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                {renderFirstElement()}
                <Grid item xs={columnSpan(3, 4)}>
                  {renderFilterControl(3)}
                </Grid>
                <Grid item xs={columnSpan(4, 4)}>
                  {renderFilterControl(4)}
                </Grid>
                <Grid item xs={columnSpan(5, 4)}>
                  {renderFilterControl(5)}
                </Grid>
                <Grid item xs={columnSpan(6, 4)}>
                  {renderFilterControl(6)}
                </Grid>
                <Grid item xs={columnSpan(7, 4)}>
                  {renderFilterControl(7)}
                </Grid>
                <Grid item xs={columnSpan(8, 4)}>
                  {renderFilterControl(8)}
                </Grid>
                <Grid item xs={columnSpan(9, 4)}>
                  {renderFilterControl(9)}
                </Grid>
                <Grid item xs={columnSpan(10, 4)}>
                  {renderFilterControl(10)}
                </Grid>
                <Grid item xs={columnSpan(11, 4)}>
                  {renderFilterControl(11)}
                </Grid>
                <Grid item xs={columnSpan(12, 4)}>
                  {renderFilterControl(12)}
                </Grid>
              </Grid>
            </Typography>
          </ScrollContainer>
          {!hideSaveFilterButtons && (
            <SaveApplyClearButtonContainer>
              <Button
                className="apply"
                variant="contained"
                style={{ backgroundColor: colors.coreColors.jllRed.primary }}
                onClick={applyAndSaveFilter}
                disabled={disableSaveApply}
              >
                Save & Apply
              </Button>
              <Button
                className="clear"
                variant="contained"
                style={{ backgroundColor: "grey" }}
                onClick={clearAndSaveFilter}
                disabled={disableSaveApply}
              >
                Clear & Apply
              </Button>
            </SaveApplyClearButtonContainer>
          )}
          <ApplyClearButtonContainer>
            <Button
              className="apply"
              variant="contained"
              style={{ backgroundColor: colors.coreColors.jllRed.primary }}
              onClick={applyFilter}
            >
              Apply
            </Button>
            <Button
              className="clear"
              variant="contained"
              style={{ backgroundColor: "grey" }}
              onClick={clearFilter}
            >
              Clear
            </Button>
          </ApplyClearButtonContainer>
        </FilterContainer>
      </Container>
    </Modal>
  );
};

export default FilterModal;
